/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_2_Task_2_Day_StreakInputs */

const en_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus for 2 Days in a Row`)
};

const ar_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ركّز لمدة يومين متتاليين`)
};

const de_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus für 2 Tage in Folge`)
};

const es_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concéntrate durante 2 días seguidos`)
};

const fr_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se concentrer pendant 2 jours consécutifs`)
};

const it_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentrati per 2 giorni di fila`)
};

const ja_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2日連続で集中`)
};

const ko_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2일 연속 집중하기`)
};

const pt_br_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha o foco por 2 dias seguidos`)
};

const ru_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сосредотачивайтесь в течение 2 дней подряд`)
};

const th_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสต่อเนื่อง 2 วันติด`)
};

const tr_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 Gün Üst Üste Odaklan`)
};

const zh_cn_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连续专注 2 天`)
};

const zh_tw_phase_2_task_2_day_streak = /** @type {(inputs: Phase_2_Task_2_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連續專注 2 天`)
};

/**
* | output |
* | --- |
* | "Focus for 2 Days in a Row" |
*
* @param {Phase_2_Task_2_Day_StreakInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const phase_2_task_2_day_streak = /** @type {((inputs?: Phase_2_Task_2_Day_StreakInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_2_Task_2_Day_StreakInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phase_2_task_2_day_streak(inputs)
	if (locale === "ar") return ar_phase_2_task_2_day_streak(inputs)
	if (locale === "de") return de_phase_2_task_2_day_streak(inputs)
	if (locale === "es") return es_phase_2_task_2_day_streak(inputs)
	if (locale === "fr") return fr_phase_2_task_2_day_streak(inputs)
	if (locale === "it") return it_phase_2_task_2_day_streak(inputs)
	if (locale === "ja") return ja_phase_2_task_2_day_streak(inputs)
	if (locale === "ko") return ko_phase_2_task_2_day_streak(inputs)
	if (locale === "pt_br") return pt_br_phase_2_task_2_day_streak(inputs)
	if (locale === "ru") return ru_phase_2_task_2_day_streak(inputs)
	if (locale === "th") return th_phase_2_task_2_day_streak(inputs)
	if (locale === "tr") return tr_phase_2_task_2_day_streak(inputs)
	if (locale === "zh_cn") return zh_cn_phase_2_task_2_day_streak(inputs)
	return zh_tw_phase_2_task_2_day_streak(inputs)
});